import React, { useEffect, useState } from 'react';
import SecondaryNavBar from '../../../Components/SecondaryNavBar/SecondaryNavBar';

import 'Container/Formulaires/ChangementAdresse/ChangementAdresse.scss';
import { useSelector } from "react-redux";
import LoadingOverlay from "../../../Components/LoadingOverlay/LoadingOverlay";
import { postChangementContrat } from "../../../api/modificationContratService";
import moment from "moment/moment";
import { getLabelInput } from "../../../utils/stringUtils";
import { renderError, upperCaseRemoveAccent } from "../../../utils/formUtils";
import {v4 as uuidv4} from 'uuid';
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";

export default function ChangementAdresse({ isInside }) {

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        infosCorrespondant,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const CONF = window?.confPub;
    const CODES_FORMULAIRES = CONF?.CODES?.CODES_FORMULAIRES;
    const TYPE_INDIVIDU = CONF?.TYPE_INDIVIDU
    const PATTERNS = CONF?.PATTERNS
    const INPUTS = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.ADRESSE

    const {
        CODE_POSTAL,
        LOCALITE,
        LIEU_DIT,
        NUMERO_VOIE,
        CODE_BTQ,
        NOM_VOIE,
        POINT_REMISE_COURRIER,
        COMPLEMENT_IDENTIFICATION_GEO,
    } = INPUTS

    const DATE_EFFET = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.DATE_EFFET

    const ALL_INPUTS_PAGE = {
        ...INPUTS,
        DATE_EFFET
    }

    const titreChangementAdresse = "Changement d'adresse";

    const [disabledForm, setDisabledForm] = useState(false);
    const [submitted, setSubmitted] = useState(false)
    const [sendSuccess, setSendSuccess] = useState({
        isSuccess: false,
        message: false,
        display: false,
    })

    const adresseInit = {
        [DATE_EFFET?.NAME]: {
            name: DATE_EFFET?.NAME,
            value: '',
            invalid: DATE_EFFET?.ERRORS?.MANDATORY
        },
        [CODE_POSTAL?.NAME]: {
            name: CODE_POSTAL?.NAME,
            value: '',
            invalid: CODE_POSTAL?.ERRORS?.MANDATORY,
        },
        [LOCALITE?.NAME]: {
            name: LOCALITE?.NAME,
            value: '',
            invalid: LOCALITE?.ERRORS?.MANDATORY,
        },
        [LIEU_DIT?.NAME]: {
            name: LIEU_DIT?.NAME,
            value: '',
            invalid: false,
        },
        [NUMERO_VOIE?.NAME]: {
            name: NUMERO_VOIE?.NAME,
            value: '',
            invalid: false,
        },
        [CODE_BTQ?.NAME]: {
            name: CODE_BTQ?.NAME,
            value: '',
            invalid: false,
        },
        [NOM_VOIE?.NAME]: {
            name: NOM_VOIE?.NAME,
            value: '',
            invalid: NOM_VOIE?.ERRORS?.MANDATORY,
        },
        [POINT_REMISE_COURRIER?.NAME]: {
            name: POINT_REMISE_COURRIER?.NAME,
            value: '',
            invalid: false,
        },
        [COMPLEMENT_IDENTIFICATION_GEO?.NAME]: {
            name: COMPLEMENT_IDENTIFICATION_GEO?.NAME,
            value: '',
            invalid: false,
        },
    }

    const [newAdresse, setNewAdresse] = useState(adresseInit)

    const checkInput = (name, value, type) => {

      const trimValue = typeof value === "string" ? value?.trim() : value
        let invalid = false

        switch (name) {

            case DATE_EFFET?.NAME:

                if (!value) {

                    invalid = DATE_EFFET?.ERRORS?.MANDATORY

                } else {

                    const dateMoment = moment(value, CONF?.PATTERNS?.YYYY_DASH_MM_DASH_DD)

                    invalid = !dateMoment.isValid() ? DATE_EFFET?.ERRORS?.INVALID : false
                }

                break

            case CODE_POSTAL?.NAME:

                if (!trimValue) {

                    invalid = CODE_POSTAL?.ERRORS?.MANDATORY;

                } else if (trimValue && trimValue.length < 5) {

                    invalid = CODE_POSTAL?.ERRORS?.MAX_LENGTH

                } else if (trimValue && trimValue.length > 5) {

                    invalid = CODE_POSTAL?.ERRORS?.MIN_LENGTH

                } else if (!new RegExp(/^[0-9]{5}$/).test(trimValue)) {

                    invalid = CODE_POSTAL?.ERRORS?.INVALID

                } else if (trimValue === "00000") {

                    invalid = CODE_POSTAL?.ERRORS?.FIVE_ZERO
                }
                break

            case LOCALITE?.NAME:

                if (!trimValue) {

                    invalid = LOCALITE?.ERRORS?.MANDATORY

                } else if (value.length > 32) {

                    invalid = LOCALITE?.ERRORS?.MAX_LENGTH

                } else if (!new RegExp(/^[A-Za-zÀ-ú '\-]{1,32}$/).test(trimValue)) {

                    invalid = LOCALITE?.ERRORS?.INVALID
                }
                break;

            case LIEU_DIT?.NAME:

                if (value.length > 38) {

                    invalid = LIEU_DIT?.ERRORS?.MAX_LENGTH

                } else if (value && !new RegExp(/^[A-Za-zÀ-ú '\-]{1,38}$/).test(trimValue)) {

                    invalid = LIEU_DIT?.ERRORS?.INVALID
                }
                break;

            case NUMERO_VOIE?.NAME:

                if (trimValue && trimValue.length > 4) {

                    invalid = NUMERO_VOIE?.ERRORS?.MAX_LENGTH

                } else if (trimValue && !new RegExp(/^[0-9]{1,4}$/).test(trimValue)) {

                    invalid = NUMERO_VOIE?.ERRORS?.INVALID
                }
                break;

            case CODE_BTQ?.NAME:

                const isMatch = CODE_BTQ?.OPTIONS.some(option => option.VALUE === trimValue);

                if (!isMatch) {
                    value = CODE_BTQ?.ERRORS?.NOT_OPTION
                }
                break

            case NOM_VOIE?.NAME:

                if (!trimValue) {

                    invalid = NOM_VOIE?.ERRORS?.MANDATORY

                } else if (trimValue.length > 32) {

                    invalid = NOM_VOIE?.ERRORS?.MAX_LENGTH

                } else if (!new RegExp(/^[A-Za-zÀ-ú0-9\- ']{1,32}$/).test(trimValue)) {

                    invalid = NOM_VOIE?.ERRORS?.INVALID
                }
                break

            case POINT_REMISE_COURRIER?.NAME:

                if (value.length > 38) {

                    invalid = POINT_REMISE_COURRIER?.ERRORS?.MAX_LENGTH

                } else if (value && !new RegExp(/^[A-Za-zÀ-ú0-9\- ']{1,38}$/).test(trimValue)) {

                    invalid = POINT_REMISE_COURRIER?.ERRORS?.INVALID
                }

                break;

            case COMPLEMENT_IDENTIFICATION_GEO?.NAME:

                if (value.length > 38) {

                    invalid = COMPLEMENT_IDENTIFICATION_GEO?.ERRORS?.MAX_LENGTH

                } else if (value && !new RegExp(/^[A-Za-zÀ-ú0-9\- ']{1,38}$/).test(trimValue)) {

                    invalid = COMPLEMENT_IDENTIFICATION_GEO?.ERRORS?.INVALID
                }
                break
        }

        return invalid
    }

    const handleInput = (e) => {

        const { name, value: rawValue, type } = e?.target

        const value = type === 'text' ? upperCaseRemoveAccent(rawValue) : rawValue

        const invalid = checkInput(name, value)

        setNewAdresse({
            ...newAdresse,
            [name]: {
                ...newAdresse?.[name],
                value: value,
                invalid: invalid,
            }
        })
    }

    const getConfRef = (name) => {

        return Object.values(ALL_INPUTS_PAGE)?.find(({ NAME }) => NAME === name)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setDisabledForm(true)

        const champ = [
            {
                label: "Numéro MNH",
                valeur: detailPersonne?.contrat?.[0]?.numeroContrat
            },
            {
                label: "Nom MP",
                valeur: detailPersonne?.nom
            },
            {
                label: "Prénom MP",
                valeur: detailPersonne?.prenom
            }
        ];

        let invalidForm = false

        const retourAdresse = Object.values(newAdresse).map(champAdresse => {

            const { value, name } = champAdresse

            const invalid = checkInput(name, value)

            invalidForm = !invalidForm ? invalid : invalidForm

            if (!invalid && value) {

                const confField = getConfRef(champAdresse?.name)

                const arrayElement = {
                    label: confField?.LABEL,
                    valeur: champAdresse?.value
                }

                champ.push(arrayElement)

                return {
                    label: confField?.LABEL,
                    valeur: champAdresse?.value
                }
            }
        })

        if (!invalidForm) {

            const formToSend = {
                idGrm: keycloakReduce?.decodedToken?.idGrm,
                idGrcDemandeur: infosCorrespondant?.idGrc,
                idGrcBeneficiaire: detailPersonne?.idPersGrc,
                codeDomaine: contrat?.gammeContrat,
                codeQualification: CODES_FORMULAIRES?.CHANGEMENT_ADRESSE,
                champ: champ
            }

            console.log("formToSend")
            console.log(formToSend)

            try {

                const resp = await postChangementContrat(formToSend)

                setSendSuccess({
                    isSuccess: true,
                    message: false,
                    display: true,
                })

                erasedInputs(false)

                console.log("resp")
                console.log(resp)

            } catch (err) {
                console.log("err", err);

                setSendSuccess({
                    isSuccess: false,
                    message: false,
                    display: true,
                })

                setSubmitted(true)

            } finally {
                setDisabledForm(false)
            }
        } else {

            setDisabledForm(false)
            setSubmitted(true)
        }
    }

    const erasedInputs = (all) => {

        setSubmitted(false)
        setNewAdresse(adresseInit)

        if (all) {
            setSendSuccess({
                isSuccess: false,
                message: false,
                display: false,
            })
        }
    }

    return (
        <div className='container mt-3'>

            { !isInside && <SecondaryNavBar/> }

            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ `${ !isInside ? 'col-lg-8' : '' }` }>

                    <div className="card">
                        <form onSubmit={ handleSubmit }>
                            <div className="card-header">
                                <h2>{ titreChangementAdresse }</h2>
                            </div>
                            <div className="card-body">

                                <div>
                                    <h4>Adresse actuelle :</h4>
                                </div>

                                <dl className="row">
                                    <dt className="col-sm-5">
                                        Numéro et nom de la voie :
                                    </dt>
                                    <dd className="col-sm-7">
                                        { detailPersonne?.adrL2 }
                                    </dd>

                                    <dt className="col-sm-5">
                                        Code postal :
                                    </dt>
                                    <dd className="col-sm-7">
                                        { detailPersonne?.codePostal }
                                    </dd>

                                    <dt className="col-sm-5">
                                        Ville :
                                    </dt>
                                    <dd className="col-sm-7">
                                        { detailPersonne?.ville }
                                    </dd>
                                </dl>

                                <fieldset className={ `mt-3 ` }>

                                    <h4>Nouvelle adresse</h4>

                                    <div className="row">
                                        <div className='col-lg-6'>
                                            <label
                                                htmlFor={ DATE_EFFET?.NAME }>
                                                { getLabelInput(DATE_EFFET) }
                                            </label>
                                            <input
                                                id={ DATE_EFFET?.NAME }
                                                name={ DATE_EFFET?.NAME }
                                                className="form-control"
                                                value={ newAdresse?.[DATE_EFFET?.NAME]?.value }
                                                onChange={ handleInput }
                                                type="date"
                                            />
                                            { submitted && newAdresse?.[DATE_EFFET?.NAME]?.invalid
                                                && renderError(newAdresse?.[DATE_EFFET?.NAME]?.invalid) }
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className='col-lg-6 mt-3'>
                                            <label
                                                htmlFor={ CODE_POSTAL?.NAME }
                                                className='form-label'>
                                                { getLabelInput(CODE_POSTAL) }
                                            </label>
                                            <input
                                                type="text"
                                                name={ CODE_POSTAL?.NAME }
                                                id={ CODE_POSTAL?.NAME }
                                                value={ newAdresse?.[CODE_POSTAL?.NAME]?.value }
                                                onChange={ handleInput }
                                                className='form-control'
                                                placeholder={ CODE_POSTAL?.PLACEHOLDER }
                                            />
                                            { submitted && newAdresse?.[CODE_POSTAL?.NAME]?.invalid
                                                && renderError(newAdresse?.[CODE_POSTAL?.NAME]?.invalid) }
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label
                                                htmlFor={ LOCALITE?.NAME }
                                                className='form-label'>
                                                { getLabelInput(LOCALITE) }
                                            </label>
                                            <input
                                                type="text"
                                                name={ LOCALITE?.NAME }
                                                id={ LOCALITE?.NAME }
                                                value={ newAdresse?.[LOCALITE?.NAME]?.value }
                                                onChange={ handleInput }
                                                className='form-control'
                                                placeholder={ LOCALITE?.PLACEHOLDER }
                                            />
                                            { submitted && newAdresse?.[LOCALITE?.NAME]?.invalid
                                                && renderError(newAdresse?.[LOCALITE?.NAME]?.invalid) }
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label
                                                htmlFor={ LIEU_DIT?.NAME }
                                                className='form-label'>
                                                { getLabelInput(LIEU_DIT) }
                                            </label>
                                            <input
                                                type="text"
                                                name={ LIEU_DIT?.NAME }
                                                id={ LIEU_DIT?.NAME }
                                                value={ newAdresse?.[LIEU_DIT?.NAME]?.value }
                                                onChange={ handleInput }
                                                className='form-control'
                                                placeholder={ LIEU_DIT?.PLACEHOLDER }
                                            />
                                            { submitted && newAdresse?.[LIEU_DIT?.NAME]?.invalid
                                                && renderError(newAdresse?.[LIEU_DIT?.NAME]?.invalid) }
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label
                                                htmlFor={ NUMERO_VOIE?.NAME }
                                                className='form-label'>
                                                { getLabelInput(NUMERO_VOIE) }
                                            </label>
                                            <input
                                                type="text"
                                                name={ NUMERO_VOIE?.NAME }
                                                id={ NUMERO_VOIE?.NAME }
                                                className='form-control'
                                                value={ newAdresse?.[NUMERO_VOIE?.NAME]?.value }
                                                onChange={ handleInput }
                                                placeholder={ NUMERO_VOIE?.PLACEHOLDER }
                                            />
                                            { submitted && newAdresse?.[NUMERO_VOIE?.NAME]?.invalid
                                                && renderError(newAdresse?.[NUMERO_VOIE?.NAME]?.invalid) }
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label
                                                htmlFor={ CODE_BTQ?.NAME }
                                                className='form-label'>
                                                { getLabelInput(CODE_BTQ) }
                                            </label>
                                            <select name={ CODE_BTQ?.NAME }
                                                    className='form-control mb-0'
                                                    value={ newAdresse?.[CODE_BTQ?.NAME]?.value }
                                                    onChange={ handleInput }>
                                                <option value="" disabled>Sélectionner</option>
                                                { CODE_BTQ?.OPTIONS?.map(option => {
                                                    return (
                                                        <option key={ uuidv4() }
                                                                value={ option?.VALUE }>{ option?.LABEL }</option>
                                                    )
                                                }) }
                                            </select>
                                            <div className="fleche-select"/>
                                            { submitted && newAdresse?.[CODE_BTQ?.NAME]?.invalid
                                                && renderError(newAdresse?.[CODE_BTQ?.NAME]?.invalid) }
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label
                                                htmlFor={ NOM_VOIE?.NAME }
                                                className='form-label'>
                                                { getLabelInput(NOM_VOIE) }
                                            </label>
                                            <input
                                                type="text"
                                                name={ NOM_VOIE?.NAME }
                                                id={ NOM_VOIE?.NAME }
                                                className='form-control'
                                                value={ newAdresse?.[NOM_VOIE?.NAME]?.value }
                                                onChange={ handleInput }
                                                placeholder={ NOM_VOIE?.PLACEHOLDER }
                                            />
                                            { submitted && newAdresse?.[NOM_VOIE?.NAME]?.invalid
                                                && renderError(newAdresse?.[NOM_VOIE?.NAME]?.invalid) }
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label
                                                htmlFor={ POINT_REMISE_COURRIER?.NAME }
                                                className='form-label'>
                                                { getLabelInput(POINT_REMISE_COURRIER) }
                                            </label>
                                            <input
                                                type="text"
                                                name={ POINT_REMISE_COURRIER?.NAME }
                                                id={ POINT_REMISE_COURRIER?.NAME }
                                                className='form-control'
                                                value={ newAdresse?.[POINT_REMISE_COURRIER?.NAME]?.value }
                                                onChange={ handleInput }
                                                placeholder={ POINT_REMISE_COURRIER?.PLACEHOLDER }
                                            />
                                            { submitted && newAdresse?.[POINT_REMISE_COURRIER?.NAME]?.invalid
                                                && renderError(newAdresse?.[POINT_REMISE_COURRIER?.NAME]?.invalid) }
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label
                                                htmlFor={ COMPLEMENT_IDENTIFICATION_GEO?.NAME }
                                                className='form-label'>
                                                { getLabelInput(COMPLEMENT_IDENTIFICATION_GEO) }
                                            </label>
                                            <input
                                                type="text"
                                                name={ COMPLEMENT_IDENTIFICATION_GEO?.NAME }
                                                id={ COMPLEMENT_IDENTIFICATION_GEO?.NAME }
                                                className='form-control'
                                                value={ newAdresse?.[COMPLEMENT_IDENTIFICATION_GEO?.NAME]?.value }
                                                onChange={ handleInput }
                                                placeholder={ COMPLEMENT_IDENTIFICATION_GEO?.PLACEHOLDER }
                                            />
                                            { submitted && newAdresse?.[COMPLEMENT_IDENTIFICATION_GEO?.NAME]?.invalid
                                                && renderError(newAdresse?.[COMPLEMENT_IDENTIFICATION_GEO?.NAME]?.invalid) }
                                        </div>
                                    </div>
                                </fieldset>

                                <MessageInfoEnvoi
                                    isSuccess={ sendSuccess?.isSuccess }
                                    message={ sendSuccess?.message }
                                    display={ sendSuccess?.display }
                                />
                            </div>

                            <div className="card-footer">
                                <div className='d-flex justify-content-end'>
                                    <button
                                        type='submit'
                                        className="btn btn-primary"
                                    >
                                        Envoyer
                                    </button>
                                    <button
                                        type='button'
                                        className="btn btn-secondary ms-2"
                                        onClick={ ()  => erasedInputs(true)}
                                    >
                                        Effacer
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </main>
        </div>
    )
}